<section class="add-product-wrapper">
  <db-product-actions-header
    [isEdit]="isEdit"
    (onUpdate)="saveProduct(false, false)"
    [productUrl]="productUrl"
    [statusForm]="descriptionForm.get('status')"
    [isPublished]="isPublished"
    (onSave)="saveProduct($event)"
    (onDiscard)="discardForm()">
  </db-product-actions-header>
  <section class="product-wrapper">
    <section class="main-container">
      <div class="product-edit-section">
        <db-product-description [descriptionForm]="descriptionForm">
        </db-product-description>
        <db-product-media [mediaForm]="mediaForm"
                          [websiteId]="website.id">
        </db-product-media>
      </div>

      <db-product-main-pricing
        *ngIf="!(activeAttributes$|async)?.length"
        [currencySymbol]="_productAddHelper.currency|async"
        [hasAttributes]="!!((activeAttributes$|async)?.length)"
        [pricingForm]="pricingForm">
      </db-product-main-pricing>
      <db-product-price-variants
        *ngIf="(activeAttributes$|async)?.length"
        [currency]="_productAddHelper.currency|async"
        (applyVariations)="applyVariations()"
        [inventoryForm]="inventoryForm"
        [variantsForm]="variantsForm"
        [variantsDialogForm]="variantsDialogForm"
        [activeAttributes]="activeAttributes"
        [attributes]="attributes"
        (openVariantsModal)="onShowVariations($event)">
      </db-product-price-variants>
      <db-product-inventory
        (apply)="applyVariations()"
        [variantsForm]="variantsForm"
        [activeAttributes]="activeAttributes$|async"
        [attributes]="attributes"
        [hasAttributes]="!!((activeAttributes$|async)?.length)"
        [inventoryForm]="inventoryForm">
      </db-product-inventory>
      <db-product-linked-products
        [products]="promoteProductList"
        [linkedProductsForm]="linkedProductsForm">
      </db-product-linked-products>
      <db-product-tax [taxList]="taxClasses"
                      [taxClassForm]="taxForm">
      </db-product-tax>
      <db-product-shipping [shippingForm]="shippingForm"
                           [isEdit]="isEdit"
                           [measurements]="_productAddHelper.measurements|async"
                           [shippingClasses]="shippingClassList" >
      </db-product-shipping>
    </section>
    <section class="sidebar">
      <db-product-category
        [adminUrl]="website?.adminUrl"
        [templates]="templates"
        [categories]="categories"
        [tags]="tags"
        (onCreateCategory)="createCategory($event)"
        (onCreateCollection)="createTag($event)"
        [categoryForm]="categoryForm"></db-product-category>
    </section>
  </section>
</section>
<db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>


